import React from "react";
import styled from "styled-components";

const AiAvatarBadge = styled.div`
  background: #4d54d1;
`;

export function Loader() {
  return (
    <div className="flex items-center gap-2 px-4 py-3">
      <AiAvatarBadge className="w-6 h-6 rounded-lg flex items-center justify-center text-[10px] font-semibold text-white flex-shrink-0">
        AI
      </AiAvatarBadge>
      <div className="flex gap-1">
        <span
          className="block w-2 h-2 rounded-full animate-bounce [animation-delay:-0.3s]"
          style={{ backgroundColor: "#4D54D1" }}
        />
        <span
          className="block w-2 h-2 rounded-full animate-bounce [animation-delay:-0.15s]"
          style={{ backgroundColor: "#4D54D1" }}
        />
        <span
          className="block w-2 h-2 rounded-full animate-bounce"
          style={{ backgroundColor: "#4D54D1" }}
        />
      </div>
    </div>
  );
}
